import { getEwpApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    body,
  }, action, state) => ({
    url: `${getEwpApiUrl(state)}/travel/v1/email/cancel`,
    opts: {
      timeout: 30e3,
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body,
    },
  }),
};
